import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { completeAuthGuardLogin } from '../context/AuthContext';

const AUTH_TOKEN_PARAM = 'access_token';
const REDIRECT_AFTER_KEY = 'authguard_redirect_after_login';

const AuthGuardRedirect: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string>('');

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const token = params.get(AUTH_TOKEN_PARAM);
      if (!token) {
        setError('Missing access token');
        return;
      }

      // Save token and derived user
      completeAuthGuardLogin(token);

      // Compute where to go next
      const next = localStorage.getItem(REDIRECT_AFTER_KEY) || '/';
      localStorage.removeItem(REDIRECT_AFTER_KEY);

      // Use replace to avoid keeping the callback URL in history
      navigate(next, { replace: true });
    } catch (e: any) {
      console.error('AuthGuard redirect handling failed:', e);
      setError(e?.message || 'Authentication failed');
    }
  }, [navigate]);

  if (error) {
    return (
      <div className="p-6">
        <h2 className="text-xl font-semibold mb-2">Authentication Error</h2>
        <p className="text-red-600">{error}</p>
        <button className="mt-4 px-4 py-2 bg-blue-600 text-white rounded" onClick={() => navigate('/login')}>
          Back to Login
        </button>
      </div>
    );
  }

  return <div className="p-6">Completing sign-in...</div>;
};

export default AuthGuardRedirect;


